import { frontendURL } from '../../../../helper/URLHelper';
import {
  TASK_MANAGE_PERMISSIONS,
  TASK_CREATE_PERMISSIONS,
  TASK_EDIT_PERMISSIONS,
  TASK_DELETE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/tasks'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'tasks_wrapper',
          meta: {
            permissions: [
              'administrator',
              TASK_MANAGE_PERMISSIONS,
              TASK_CREATE_PERMISSIONS,
              TASK_EDIT_PERMISSIONS,
              TASK_DELETE_PERMISSIONS,
            ],
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'settings_tasks',
          meta: {
            permissions: [
              'administrator',
              TASK_MANAGE_PERMISSIONS,
              TASK_CREATE_PERMISSIONS,
              TASK_EDIT_PERMISSIONS,
              TASK_DELETE_PERMISSIONS,
            ],
          },
          component: Index,
        },
      ],
    },
  ],
}; 
